import React from 'react';
import cs from 'classnames';
import {reduxForm} from 'redux-form';
import {connect} from 'react-redux';

import * as modes from '~/modules/modal/modes';
import {modalChange} from '~/modules/modal/actions';
import {signUp} from '~/modules/user/actions';
import Button from '~/components/common/Button';
import LabeledInput from '~/components/common/LabeledInput';
// import DotMcValidate from '~/components/common/DotMcValidate';
import FormHeader from '../FormHeader';
import ErrorBlock from '../Error';
import mapDispatch from '~/misc/mapDispatch';

import authPageCSS from '~/components/authpage.css';
import sharedCSS from '~/components/shared.css';

class SignUpForm extends React.Component {
  constructor(props) {
    super(props);
    this.subMit = this.subMit.bind(this);
    this.wrapClick = this.wrapClick.bind(this);
    this.state = {
      showdot: true,
    };
  }

  render() {
    const props = this.props;
    return (
      <form data-qa='signup-form'>
        <FormHeader context={""} defaultTitle='Sign up'/>
        <div className={authPageCSS.inputs}>
          <LabeledInput
            data-qa='email-input'
            autoFocus='true'
            mods={['wide', 'large']}
            label='Email'
            {...props.fields.email}
          />
          <LabeledInput
            data-qa='password-input'
            mods={['wide', 'large']}
            label='Password'
            type='password'
            {...props.fields.password}
          />
          <LabeledInput
            data-qa='password-confirm-input'
            mods={['wide', 'large']}
            label='Confirm password'
            type='password'
            {...props.fields.passwordAgain}
          />
          {/* { props.dot_sign_switch === 1
            && <DotMcValidate wrapClick={this.wrapClick} {...props} />
          } */}
        </div>
        
        <Button
          data-qa='signup-button'
          mods={['wide', 'large', 'action']}
          onClick={this.subMit}
        >
          {props.submitting ? '...' : 'Create Account'}
        </Button>
        {/* <ErrorBlock wrap={props.errorWrap}>{props.validateMessage}</ErrorBlock> */}
        <ErrorBlock wrap={props.errorWrap}>{props.signUpErrorMessage}</ErrorBlock>
        <div className={authPageCSS.footLinks}>
          <span className={cs(sharedCSS.a, 'qa-login-link')} onClick={props.login}>Log in</span>
        </div>
        <div>
          By clicking on "Create Account" button, you agree to our <a href='https://truckerpath.com/terms-of-service' target="_blank">Terms of Service</a> and <a href='https://truckerpath.com/privacy-policy' target="_blank">Privacy Policy</a>.
        </div>
      </form>
    );
  }

  wrapClick(e) {
    const typeValue = e.currentTarget.getAttribute('data-type') !== 'mc';
    this.setState({
      showdot: typeValue,
    });
  }

  subMit() {
    const formData = {};
    const oldField = this.props.fields;

    Object.keys(oldField).forEach((key) => {
      formData[key] = oldField[key].value;
    });

    const data = {
      email: formData.email,
      password: formData.password,
      passwordAgain: formData.passwordAgain,
      dot: this.state.showdot ? formData.dot : null,
      mc: this.state.showdot ? null : formData.mc,
    };
    return this.props.signUp(data);
  }
}

export default connect(
  (state) => ({
    signUpErrorMessage: state.user.signUpErrorMessage,
    dot_sign_switch: state.dots.data.dot_sign_switch,
  }),
  mapDispatch({
    onSubmit: (props, formData) => signUp({
      email: formData.email,
      password: formData.password,
      passwordAgain: formData.passwordAgain,
      // dot: formData.dot,
      // mc: formData.mc,
    }),
    signUp: (props, data) => signUp({
      ...data,
      nextAction: props.context.nextAction
    }),
    login: (props) => modalChange(modes.LOGIN, {
      nextAction: props.context.nextAction
    }),
  })
)(reduxForm(
  {
    form: 'signup',
    fields: [
      'email',
      'password',
      'passwordAgain',
      'dot',
      'mc',
    ],
  }
)(SignUpForm));



// WEBPACK FOOTER //
// ./src/components/user/SignUpForm/index.js